"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _operators = require("rxjs/operators");

var actions = _interopRequireWildcard(require("./personalTemplateSettings.actions"));

var transformers = _interopRequireWildcard(require("./personalTemplateSettings.transformers"));

var getTemplatesEpic = function getTemplatesEpic(action$, state$, _ref) {
  var personalSettingsService = _ref.personalSettingsService,
      messagesService = _ref.messagesService;
  return action$.pipe((0, _reduxObservable.ofType)(actions.getTemplatesRequest), (0, _operators.mergeMap)(function () {
    return personalSettingsService.getTemplates().pipe((0, _operators.mergeMap)(function (response) {
      return [actions.getTemplatesSuccess(transformers.transformTemplates(response.data))];
    }), (0, _operators.catchError)(messagesService.errorHandler({
      callbacks: actions.getTemplatesFailed
    })), (0, _operators.takeUntil)(action$.ofType(actions.getTemplatesRequest)));
  }));
};

var createTemplateEpic = function createTemplateEpic(action$, state$, _ref2) {
  var personalSettingsService = _ref2.personalSettingsService,
      messagesService = _ref2.messagesService;
  return action$.pipe((0, _reduxObservable.ofType)(actions.createTemplate), (0, _operators.mergeMap)(function (_ref3) {
    var template = _ref3.payload;
    return personalSettingsService.createTemplate(template).pipe((0, _operators.mergeMap)(function (response) {
      return [actions.createTemplateSuccess(response.data), messagesService.showGlobalMessage({
        type: 'success',
        text: 'Template successfully created!'
      })];
    }), (0, _operators.catchError)(messagesService.errorHandler({
      callbacks: actions.createTemplateFailed
    })), (0, _operators.takeUntil)(action$.ofType(actions.createTemplate)));
  }));
};

var updateTemplateEpic = function updateTemplateEpic(action$, state$, _ref4) {
  var personalSettingsService = _ref4.personalSettingsService,
      messagesService = _ref4.messagesService;
  return action$.pipe((0, _reduxObservable.ofType)(actions.updateTemplate), (0, _operators.mergeMap)(function (_ref5) {
    var template = _ref5.payload;
    return personalSettingsService.updateTemplate(template).pipe((0, _operators.mergeMap)(function (response) {
      return [actions.updateTemplateSuccess(response.data), messagesService.showGlobalMessage({
        type: 'success',
        text: 'Template successfully updated!'
      })];
    }), (0, _operators.catchError)(messagesService.errorHandler({
      callbacks: actions.updateTemplateFailed
    })), (0, _operators.takeUntil)(action$.ofType(actions.updateTemplate)));
  }));
};

var deleteTemplateEpic = function deleteTemplateEpic(action$, state$, _ref6) {
  var personalSettingsService = _ref6.personalSettingsService,
      messagesService = _ref6.messagesService;
  return action$.pipe((0, _reduxObservable.ofType)(actions.deleteTemplate), (0, _operators.mergeMap)(function (_ref7) {
    var templateId = _ref7.payload;
    return personalSettingsService.deleteTemplate(templateId).pipe((0, _operators.mergeMap)(function () {
      return [actions.deleteTemplateSuccess(templateId), messagesService.showGlobalMessage({
        type: 'success',
        text: 'Template has been deleted'
      })];
    }), (0, _operators.catchError)(messagesService.errorHandler({
      callbacks: actions.deleteTemplateFailed
    })), (0, _operators.takeUntil)(action$.ofType(actions.deleteTemplate)));
  }));
};

var personalTemplateSettingsEpics = [deleteTemplateEpic, updateTemplateEpic, getTemplatesEpic, createTemplateEpic];
var _default = personalTemplateSettingsEpics;
exports.default = _default;